import { StrictLocalizeFunction } from "@faire/web/common/localization";

interface ICommunities {
  title: string;
  description: string;
}

export const FAIRE_EMPLOYEE_GROUPS = (
  strictLocalize: StrictLocalizeFunction
): ICommunities[] => [
  {
    title: strictLocalize({
      defaultMessage: "Black Faire Folk",
      description: {
        text: "Title of a resource groups open to all Faire employees",
      },
    }),
    description: strictLocalize({
      defaultMessage:
        "Fostering and promoting an inclusive space to celebrate the diversity of black employees at Faire.",
      description: {
        text: "description of a resource groups open to all Faire employees",
      },
    }),
  },
  {
    title: strictLocalize({
      defaultMessage: "Faire Femmes",
      description: {
        text: "Title of a resource groups open to all Faire employees",
      },
    }),
    description: strictLocalize({
      defaultMessage:
        "A community for women, dedicated to empowering those at Faire who identify as women to succeed.",
      description: {
        text: "description of a resource groups open to all Faire employees",
      },
    }),
  },
  {
    title: strictLocalize({
      defaultMessage: "Faire Femmes in Tech",
      description: {
        text: "Title of a resource groups open to all Faire employees",
      },
    }),
    description: strictLocalize({
      defaultMessage:
        "Nurturing a sense of belonging among women engineers at Faire, by supporting career growth " +
        "and development, facilitating professional connections, and mentorship.",
      description: {
        text: "description of a resource groups open to all Faire employees",
      },
    }),
  },
  {
    title: strictLocalize({
      defaultMessage: "Faire Fusion",
      description: {
        text: "Title of a resource groups open to all Faire employees",
      },
    }),
    description: strictLocalize({
      defaultMessage:
        "A tight-knit community that provides support and mentorship, while celebrating the " +
        "diverse spectrum of cultures represented in the AAPI community at Faire.",
      description: {
        text: "description of a resource groups open to all Faire employees",
      },
    }),
  },
  {
    title: strictLocalize({
      defaultMessage: "Fairents",
      description: {
        text: "Title of a resource groups for employees who are parents",
      },
    }),
    description: strictLocalize({
      defaultMessage:
        "A community of parents supporting one another in their professional ambitions and journeys as parents.",
      description: {
        text: "description of a resource groups open to all Faire employees",
      },
    }),
  },
  {
    title: strictLocalize({
      defaultMessage: "Flaire",
      description: {
        text: "Title of a resource groups open to all Faire employees",
      },
    }),
    description: strictLocalize({
      defaultMessage:
        "An inclusive LGBTQ+ community empowering everyone to express their whole selves at work.",
      description: {
        text: "description of a resource groups open to all Faire employees",
      },
    }),
  },
  {
    title: strictLocalize({
      defaultMessage: "Hue",
      description: {
        text: "Title of a resource groups open to all Faire employees",
      },
    }),
    description: strictLocalize({
      defaultMessage:
        "Providing an inclusive space where people of color and their allies can feel comfortable being " +
        "themselves and talk to others who get it.",
      description: {
        text: "description of a resource groups open to all Faire employees",
      },
    }),
  },
  {
    title: strictLocalize({
      defaultMessage: "Somos",
      description: {
        text: "Title of a resource groups open to all Faire employees",
      },
    }),
    description: strictLocalize({
      defaultMessage:
        "Empowering and uplifting Latinx/Hispanic Faire Folk by strengthening members' connection to each other, " +
        "other Faire Folk, and the broader Faire community.",
      description: {
        text: "description of a resource groups open to all Faire employees",
      },
    }),
  },
  {
    title: strictLocalize({
      defaultMessage: "South Asian Faire Folk",
      description: {
        text: "Title of a resource groups open to all Faire employees",
      },
    }),
    description: strictLocalize({
      defaultMessage:
        "A space for all South Asians or those who have a connection to South Asian culture to connect over shared experiences.",
      description: {
        text: "description of a resource groups open to all Faire employees",
      },
    }),
  },
];
